<template>
    <div>
        <template v-if="is_boss">
            <div class="title">
                <div class="title_left">店铺名称</div>
                <div class="title_right">接收消息开关</div>
            </div>
            <template v-if="GetShopList">
                <div v-for="(item,index) in GetShopList.list" :key="index" class="body">
                    <div class="body_left">
                        <div>{{item.visitor_nick}}</div>
                        <div class="body_left_tips" :class="[item['close_remind']==1?'':'on']">{{item['close_remind']==1?'不再接收消息提醒':'有未回复消息为我提醒'}}</div>
                    </div>
                    <div class="body_right">
                        <div>
                            <van-switch class="vant_switch" :value="item['close_remind']==1?false:true" @input="switch_touch(index)" active-color="#45DB5E" inactive-color="rgb(199,199,199)" />
                        </div>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="no_power">
                {{text}}
            </div>
        </template>
    </div>
</template>
<script>
import { Switch } from 'vant';
import { mapState } from 'vuex';
import { Toast } from 'vant';
export default {
    name: 'ShopSwitch',
    data(){
        return{
            checked:[],
            is_boss: false,
            text: '',
        }
    },
    mounted(){
        this.GetShopList
        this.$store.dispatch('ShopSwitch/GetShopList',{}).then(res=>{
            if(res.code==4023){
                this.is_boss = false
                this.text = res.message
            }
            if(res.code == 1000){
                this.is_boss=true
            }
        })
    },
    components:{
        vanSwitch:Switch,
    },
    computed:{
        ...mapState({
            GetShopList: (state)=>{
                return state.ShopSwitch.GetShopList
            },
        })
    },
    methods:{
        switch_touch(index){
            let data = JSON.parse(JSON.stringify(this.GetShopList))
            data.list[index].close_remind = data.list[index].close_remind==0?1:0;
            let visitor_id= data.list[index].visitor_id
            let close_remind= data.list[index].close_remind
            this.$store.dispatch('ShopSwitch/SetRemindSwitch',{
                visitor_id: visitor_id,
                close_remind: close_remind,
            }).then(res=>{
                if(res.code == 1000){
                    this.$store.commit('ShopSwitch/SET_SWITCH',{ key:index, data:close_remind})
                    Toast('设置成功')
                }else{
                    Toast(res.message)
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>